import {createTheme, ThemeProvider} from "@mui/material/styles";
import { Stack, Box, Typography, Icon, Chip, Card, CardMedia, CardContent, Button, TextField } from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { InfoIcon, LogoutOutlined, AccountCircle, ArrowBack, EditNote } from '@mui/icons-material';

import axios from "axios";
import { AuthContext } from '../index';
import getLPTheme from '../getLPTheme';
import {useContext, useEffect, useState, useRef} from 'react';



import { BSERVICES } from '../data/database';
import getImage from '../utils/getImage';
import ItemsList from './ItemsList';
import Chat from './Chat';
import App from './App';


const AccountScreen = () => {
    const [view, setView] = useState('account');
    const [servicesStatus, setServicesStatus] = useState('active')
    const [servicePicked, setServicePicked] = useState(null);
    const { onLogout, id, phoneNumber } = useContext(AuthContext);
    const userId = id;
    const DEFAULT_USER_INFO_STATE = {
        isLoaded: false,
        data: {
            firstName: '',
            lastName: ''
        }
    }
    const [userInfo, setUserInfo] = useState(DEFAULT_USER_INFO_STATE);

    useEffect(() => {
        if (userInfo.isLoaded || !id) {
            return;
        }

        async function loadUser() {
            try {
                const resp = await axios.post(`/api/v1/users/get`, [
                    id
                ]);

                setUserInfo(prevState => ({
                    isLoaded: true,
                    data: {
                        firstName: resp.data[0]?.firstName,
                        lastName: resp.data[0]?.lastName
                    }
                }));

                setEditForm(prevState => ({...prevState,
                    data: {...prevState.data, firstName: resp.data[0]?.firstName, lastName: resp.data[0]?.lastName }
                }))

            } catch (err) {throw err;}
        }

        loadUser();

    }, [userInfo.isLoaded, id]);


    const DEFAULT_EDIT_FORM_STATE = {
        isUpdating: false,
        errors: [],
        data: {
            firstName: '',
            lastName: ''
        }
    }
    const [editForm, setEditForm] = useState(DEFAULT_EDIT_FORM_STATE)

    const [services, setServices] = useState({
        isLoaded: false, data: []
    })

    const fillById = (id, arr = []) => {
        const ix = arr.findIndex(it => it.id == id);
        if (ix != -1) {
            return arr[ix];
        }

        return { id };
    }

    const fillServices = (services = [], serviceTemplates = [], allLocations = []) => {
        return services.map(s => ({
            ...s,
            serviceTemplate: fillById(s.serviceTemplate.id, serviceTemplates),
            location: fillById(s.location.id, allLocations)
        }))
    };



    useState(() => {
        async function loadServices() {
            const [ serviceTemplates, allLocations ] = await Promise.all([loadServiceTemplates(), loadAllLocations()]);

            let url = `/api/v1/services/get`;

            try {
                const resp = await axios.post(url, {userIds: [id]});
                setServices({isLoaded: true, data: fillServices(resp.data, serviceTemplates, allLocations)});
            } catch (err) { throw err; }
        }

        loadServices();

        async function loadAllLocations() {
            let url = `/api/v1/locations`;
            try {
                const resp = await axios.get(url);
                return resp.data;
            } catch (err) { throw err; }

        }

        async function loadServiceTemplates() {
            let url = `/api/v1/services/templates`;
            try {
                const resp = await axios.get(url);
                return resp.data;
            } catch (err) { throw err; }

        }

    },[])

    const handleServicePick = (service) => {
        setServicePicked(service);
        setView('detailed');
    }

    const handleCancellService = (item) => {
        try {
            const resp = axios.post(`/api/v1/logs`, {
                logType: 'service_tech_message',
                message: 'CANCELL',
                parentId: item.id,
                userId: userId
            })
        } catch (err) { throw err; }
    }

    const getServices = (status) => {
        if (status == 'active') {
            return services.data.filter(s => {
                return s;
                // return s.logs.indexOf(log => log.message == 'CANCELLED') == -1
            });
        }


        if (status == 'notactive') {
            return services.data;
            // return services.data.filter(s => s.logs.indexOf(log => log.message == 'CANCELLED') != -1);
        }

        return [];
    }

    const handleUpdateSettings = async () => {
        setEditForm(prevState => ({...prevState, isUpdating: true}));
        try {
            const resp = await axios.patch(`/api/v1/users`, {
                id: userId,
                firstName: editForm?.data?.firstName,
                lastName: editForm?.data?.lastName
            });

        } catch (err) {
            throw err;
        }

        setEditForm(prevState => ({...prevState, isUpdating: false}));
        setUserInfo(prevState => ({...prevState, isLoaded: false}))
        setView('account');
    }

    const getView = () => {
        let element = null;

        if (view == 'account') {
            element = (
                <Box
                    sx={{
                        backgroundColor: 'rgb(0 0 0/0.05)'
                    }}
                >
                    <Stack sx={{
                        borderRadius: '20px',
                        backgroundColor: 'rgb(255 255 255)',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: '10px',
                        pb: '5px'
                    }}>
                        <Stack direction={'row'} sx={{justifyContent: 'flex-end', width: '100%'}}>
                            <EditNote
                                onClick={() => setView('edit')}
                                sx={{display: 'block', fontSize: '35px', p: 2, color: 'rgb(0 0 0/0.3)'}}/>
                        </Stack>
                        <Box sx={{pt: 10 }}>
                            <AccountCircle sx={{fontSize: '100px', color: 'rgb(0 0 0/0.15)'}}/>
                        </Box>
                        <Box sx={{p: 2 }}>
                            <Typography align={'center'} sx={{fontWeight: 'bold', fontSize: '20px'}}>{userInfo?.data?.firstName + ' ' + userInfo?.data?.lastName}</Typography>
                        </Box>
                        <Box>
                            <Typography sx={{fontSize: '14px', color: 'rgb(0 0 0/0.75)', mb: 1}} align={'center'}>{ phoneNumber }</Typography>
                        </Box>
                    </Stack>
                    <Box sx={{
                        borderRadius: '20px',
                        backgroundColor: 'rgb(255 255 255)',
                        pt: '10px'
                    }}>
                        {/*<Stack direction={'row'}  alignItems={'center'}*/}
                        {/*       sx={{*/}
                        {/*           pt: 1,*/}
                        {/*           pr: 2,*/}
                        {/*           pl: 1*/}
                        {/*       }}*/}
                        {/*       onClick={() => { setView('visits'); }}*/}
                        {/*>*/}
                        {/*    <BusinessCenterIcon sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />*/}
                        {/*    <Typography fontSize={'18px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Мои визиты</Typography>*/}
                        {/*</Stack>*/}
                        <Stack direction={'row'}  alignItems={'center'}
                               sx={{
                                   pt: 1,
                                   pr: 2,
                                   pl: 1
                               }}
                               onClick={ onLogout }
                        >
                            <LogoutOutlined sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                            <Typography fontSize={'18px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Выйти</Typography>
                        </Stack>
                    </Box>
                </Box>
            );
        } else if (view == 'visits') {
            element = (
                    <Box
                        sx={{
                            position: 'relative'
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                position: 'fixed',
                                top: 0,
                                backgroundColor: "#fff",
                                // display: { xs: 'flex', sm: 'none'},
                                zIndex: 1301 // greate than swipable drawer 1300
                            }}
                        >

                        <Icon
                            onClick={() => { setView('account')}}
                            sx={{
                                '&:hover': { cursor: 'pointer', backgroundColor: "#000", color: "#fff"},
                                p: "3px",
                                backgroundColor: "#eee",
                                borderRadius: '8px',
                                position: 'fixed', top: '40px', left: '25px'}}
                        >
                            <ArrowBack/>
                        </Icon>
                        <Stack
                            sx={{
                                pt: '100px',
                                pl: '10px',
                                pr: '20px',
                                pb: '10px',
                            }}
                            direction={'row'}
                            spacing={1}
                        >
                            <Chip
                                sx={{ fontSize: '16px',
                                    backgroundColor: servicesStatus == 'active' ? '#aaa' : '',
                                }}
                                size={'large'}
                                label={ 'Активные' }
                                onClick={() => { setServicesStatus('active')}}>
                            </Chip>
                            <Chip
                                sx={{ fontSize: '16px',
                                    backgroundColor: servicesStatus == 'notactive' ? '#aaa' : '',
                            }}
                                size={'large'}
                                label={ 'Прошедшие' }
                                onClick={() => { setServicesStatus('notactive')}}>
                            </Chip>
                        </Stack>
                        </Box>
                            <ItemsList
                                sx={{
                                    m: 1
                                }}
                                items={ getServices(servicesStatus) }
                                pickedItem={ servicePicked }
                                handleItemPick={ setServicePicked }
                                getItemId={ (item) => item?.id }
                                getItemTitle={ (item) => item?.serviceTemplate?.title }
                                getItemDescription={ (item) => item?.serviceTemplate.description }
                                getItemImages={ (item) => {
                                   return getImage(item?.serviceTemplate?.images?.map(im => im.id))
                                }}
                                getDetailedComponent={(item) => (
                                    <Stack>
                                        <Typography sx={{pt: 2}} align={'left'}>Детали массажа</Typography>
                                        <Typography sx={{pt: 2}} align={'left'}>{`Место: ${item?.location?.title}, ${item?.location?.address}`}</Typography>
                                        <Typography sx={{pt: 2}} align={'left'}>Дата и время: {item?.timeFrame?.from}</Typography>

                                        {/*<Chat*/}
                                        {/*    messages={ item?.logs?.map(log => ({id: log.id, text: log.message})) }*/}
                                        {/*    addMessage={(message) => { item?.logs?.push(message) }}*/}
                                        {/*/>*/}

                                        <Button sx={{mt:4}} variant={'contained'}
                                                onClick={() => { handleCancellService(item) }}
                                        >Отменить</Button>
                                    </Stack>
                                )}
                                getShortComponent={(item) => {

                                }}
                            />
                    </Box>
            );
        } else if (view == 'detailed') {
            element = (
                <Box
                    sx={{
                        position: 'relative'
                    }}
                >
                    <Icon
                        onClick={() => { setView('account')}}
                        sx={{
                            '&:hover': { cursor: 'pointer', backgroundColor: "#000", color: "#fff"},
                            p: "3px",
                            backgroundColor: "#eee",
                            borderRadius: '8px',
                            position: 'fixed', top: '40px', left: '25px'}}
                    >
                        <ArrowBack/>
                    </Icon>
                    <Stack
                        sx={{
                            pt: '100px',
                            pl: '20px',
                            pr: '20px'

                        }}
                        direction={'row'}
                    >
                        <Chip
                            sx={{ fontSize: '16px'}}
                            size={'large'}
                            label={ 'Активные' }
                            onClick={() => {}}>
                        </Chip>
                        <Chip
                            sx={{ fontSize: '16px'}}
                            size={'large'}
                            label={ 'Прошедшие' }
                            onClick={() => {}}>
                        </Chip>
                    </Stack>
                    <Stack sx={{pt:2}}>
                        {
                            services.data.map(service => (
                                <Card
                                    elevation={1}
                                    sx={{display: 'flex', m: 1}}
                                    onBlur={() => {}}
                                    onClick={() => {}}
                                >
                                    <Box
                                        sx={{position: 'relative'}}
                                    >
                                        <CardMedia
                                            sx={{ width: 100, height: 100, p: 1, borderRadius: '15px'}}
                                            component="img"
                                            image={service?.serviceTemplate?.images}
                                            alt=""
                                        />
                                    </Box>
                                    <CardContent
                                    >
                                        <Typography align='left' sx={{pb: 2, fontSize: '18px'}}>
                                            {service?.serviceTemplate?.title}
                                        </Typography>

                                    </CardContent>
                                </Card>
                            ))
                        }
                    </Stack>
                </Box>
            )
        }


        return element;
    }

    return (
        <App
            withNavigation
        >
            {/*{ getView() }*/}
            {
                view == 'account' ?
                    <Box
                        sx={{
                            backgroundColor: 'rgb(0 0 0/0.05)'
                        }}
                    >
                        <Stack sx={{
                            borderRadius: '20px',
                            backgroundColor: 'rgb(255 255 255)',
                            justifyContent: 'center',
                            alignItems: 'center',
                            mb: '10px',
                            pb: '5px'
                        }}>
                            <Stack direction={'row'} sx={{justifyContent: 'flex-end', width: '100%'}}>
                                <EditNote
                                    onClick={() => setView('edit')}
                                    sx={{display: 'block', fontSize: '35px', p: 2, color: 'rgb(0 0 0/0.3)'}}/>
                            </Stack>
                            <Box sx={{pt: 10 }}>
                                <AccountCircle sx={{fontSize: '100px', color: 'rgb(0 0 0/0.15)'}}/>
                            </Box>
                            <Box sx={{p: 2 }}>
                                <Typography align={'center'} sx={{fontWeight: 'bold', fontSize: '20px'}}>{userInfo?.data?.firstName + ' ' + userInfo?.data?.lastName}</Typography>
                            </Box>
                            <Box>
                                <Typography sx={{fontSize: '14px', color: 'rgb(0 0 0/0.75)', mb: 1}} align={'center'}>{ phoneNumber }</Typography>
                            </Box>
                        </Stack>
                        <Box sx={{
                            borderRadius: '20px',
                            backgroundColor: 'rgb(255 255 255)',
                            pt: '10px'
                        }}>
                            {/*<Stack direction={'row'}  alignItems={'center'}*/}
                            {/*       sx={{*/}
                            {/*           pt: 1,*/}
                            {/*           pr: 2,*/}
                            {/*           pl: 1*/}
                            {/*       }}*/}
                            {/*       onClick={() => { setView('visits'); }}*/}
                            {/*>*/}
                            {/*    <BusinessCenterIcon sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />*/}
                            {/*    <Typography fontSize={'18px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Мои визиты</Typography>*/}
                            {/*</Stack>*/}
                            <Stack direction={'row'}  alignItems={'center'}
                                   sx={{
                                       pt: 1,
                                       pr: 2,
                                       pl: 1
                                   }}
                                   onClick={ onLogout }
                            >
                                <LogoutOutlined sx={{p: 2, color: 'rgb(0 0 0/0.75)'}} />
                                <Typography fontSize={'18px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Выйти</Typography>
                            </Stack>
                        </Box>
                    </Box> : null
             }
            {
                view == 'edit' ?
                    <Box
                        sx={{
                            backgroundColor: 'rgb(0 0 0/0.05)',
                            height: '100%'
                        }}
                    >
                        <Stack direction={'row'} sx={{justifyContent: 'space-between'}}>
                            <Box
                                sx={{m: 2}}
                            >
                                <Chip
                                    sx={{backgroundColor: '#fff'}}
                                    label={'Отмена'}
                                    onClick={() => { setView('account')}}
                                ></Chip>
                            </Box>
                            <Box
                                sx={{m: 2}}
                            >
                                <Chip
                                    sx={{backgroundColor: '#fff'}}
                                    label={'Сохранить'}
                                    onClick={() => {
                                        handleUpdateSettings();
                                    }}
                                ></Chip>
                            </Box>
                        </Stack>
                        <Box sx={{
                            borderRadius: '30px',
                            backgroundColor: 'rgb(255 255 255)',
                            m: '15px',
                            p: 2
                        }}>
                            <Stack>
                                <Typography align={'left'} fontSize={'12px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Имя</Typography>
                                <TextField
                                    value={ editForm?.data?.firstName }
                                    sx={{width: '100%'}}
                                    onChange={(event) => { setEditForm(prevState =>({...prevState, data: {...prevState.data, firstName: event.target.value}}))}}
                                />
                            </Stack>
                            <Stack
                                sx={{pt: 1}}
                            >
                                <Typography align={'left'} fontSize={'12px'} sx={{color: 'rgb(0 0 0/ 0.7)'}} >Фамилия</Typography>
                                <TextField
                                    value={ editForm?.data?.lastName }
                                    sx={{width: '100%'}}
                                    onChange={(event) => { setEditForm(prevState =>({...prevState, data: {...prevState.data, lastName: event.target.value}}))}}
                                />
                            </Stack>
                        </Box>
                    </Box> : null
            }
        </App>
    );
}

export default AccountScreen;
